import MuiTooltip from "@mui/material/Tooltip";
const Tooltip = MuiTooltip;
export default Tooltip;
